///thirdpartyxero/urlauth
export const THIRD_PARTY_XERO_URL_AUTH = "THIRD_PARTY_XERO_URL_AUTH";
export const THIRD_PARTY_XERO_URL_AUTH_SUCCESS =
  "THIRD_PARTY_XERO_URL_AUTH_SUCCESS";
export const THIRD_PARTY_XERO_URL_AUTH_FAILURE =
  "THIRD_PARTY_XERO_URL_AUTH_FAILURE";
///thirdpartyxero/checkstatus
export const THIRD_PARTY_XERO_CHECK_STATUS = "THIRD_PARTY_XERO_CHECK_STATUS";
export const THIRD_PARTY_XERO_CHECK_STATUS_SUCCESS =
  "THIRD_PARTY_XERO_CHECK_STATUS_SUCCESS";
export const THIRD_PARTY_XERO_CHECK_STATUS_FAILURE =
  "THIRD_PARTY_XERO_CHECK_STATUS_FAILURE";
////thirdpartyxero/generateaccesstoken
export const THIRD_PARTY_XERO_GENERATE_ACCESS_TOKEN =
  "THIRD_PARTY_XERO_GENERATE_ACCESS_TOKEN";
export const THIRD_PARTY_XERO_GENERATE_ACCESS_TOKEN_SUCCESS =
  "THIRD_PARTY_XERO_GENERATE_ACCESS_TOKEN_SUCCESS";
export const THIRD_PARTY_XERO_GENERATE_ACCESS_TOKEN_FAILURE =
  "THIRD_PARTY_XERO_GENERATE_ACCESS_TOKEN_FAILURE";
////thirdpartyxero/assigntenant
export const THIRD_PARTY_XERO_ASSIGN_TENANT = "THIRD_PARTY_XERO_ASSIGN_TENANT";
export const THIRD_PARTY_XERO_ASSIGN_TENANT_SUCCESS =
  "THIRD_PARTY_XERO_ASSIGN_TENANT_SUCCESS";
export const THIRD_PARTY_XERO_ASSIGN_TENANT_FAILURE =
  "THIRD_PARTY_XERO_ASSIGN_TENANT_FAILURE";
////thirdpartyxero/sync/manual
export const THIRD_PARTY_XERO_SYNC_MANUAL = "THIRD_PARTY_XERO_SYNC_MANUAL";
export const THIRD_PARTY_XERO_SYNC_MANUAL_SUCCESS =
  "THIRD_PARTY_XERO_SYNC_MANUAL_SUCCESS";
export const THIRD_PARTY_XERO_SYNC_MANUAL_FAILURE =
  "THIRD_PARTY_XERO_SYNC_MANUAL_FAILURE";
///thirdpartyxero/unassigntenant
export const THIRD_PARTY_XERO_UNASSIGN_TENANT =
  "THIRD_PARTY_XERO_UNASSIGN_TENANT";
export const THIRD_PARTY_XERO_UNASSIGN_TENANT_SUCCESS =
  "THIRD_PARTY_XERO_UNASSIGN_TENANT_SUCCESS";
export const THIRD_PARTY_XERO_UNASSIGN_TENANT_FAILURE =
  "THIRD_PARTY_XERO_UNASSIGN_TENANT_FAILURE";
///thirdpartygoogle/urlauth
export const THIRD_PARTY_GOOGLE_URL_AUTH = "THIRD_PARTY_GOOGLE_URL_AUTH";
export const THIRD_PARTY_GOOGLE_URL_AUTH_SUCCESS =
  "THIRD_PARTY_GOOGLE_URL_AUTH_SUCCESS";
export const THIRD_PARTY_GOOGLE_URL_AUTH_FAILURE =
  "THIRD_PARTY_GOOGLE_URL_AUTH_FAILURE";
///thirdpartygoogle/generateaccesstoken
export const THIRD_PARTY_GOOGLE_GENERATE_ACCESS_TOKEN =
  "THIRD_PARTY_GOOGLE_GENERATE_ACCESS_TOKEN";
export const THIRD_PARTY_GOOGLE_GENERATE_ACCESS_TOKEN_SUCCESS =
  "THIRD_PARTY_GOOGLE_GENERATE_ACCESS_TOKEN_SUCCESS";
export const THIRD_PARTY_GOOGLE_GENERATE_ACCESS_TOKEN_FAILURE =
  "THIRD_PARTY_GOOGLE_GENERATE_ACCESS_TOKEN_FAILURE";
///thirdpartyhmrc/urlauth
export const THIRD_PARTY_HMRC_URL_AUTH = "THIRD_PARTY_HMRC_URL_AUTH";
export const THIRD_PARTY_HMRC_URL_AUTH_SUCCESS =
  "THIRD_PARTY_HMRC_URL_AUTH_SUCCESS";
export const THIRD_PARTY_HMRC_URL_AUTH_FAILURE =
  "THIRD_PARTY_HMRC_URL_AUTH_FAILURE";

///thirdpartybrightpay/savecredentials
export const THIRD_PARTY_BRIGHTPAY_SAVE_CREDENTIALS =
  "THIRD_PARTY_BRIGHTPAY_SAVE_CREDENTIALS";
export const THIRD_PARTY_BRIGHTPAY_SAVE_CREDENTIALS_SUCCESS =
  "THIRD_PARTY_BRIGHTPAY_SAVE_CREDENTIALS_SUCCESS";
export const THIRD_PARTY_BRIGHTPAY_SAVE_CREDENTIALS_FAILURE =
  "THIRD_PARTY_BRIGHTPAY_SAVE_CREDENTIALS_FAILURE";
///thirdpartybrightpay/urlauth
export const THIRD_PARTY_BRIGHTPAY_URL_AUTH =
  "THIRD_PARTY_BRIGHTPAY_URL_AUTH";
export const THIRD_PARTY_BRIGHTPAY_URL_AUTH_SUCCESS =
  "THIRD_PARTY_BRIGHTPAY_URL_AUTH_SUCCESS";
export const THIRD_PARTY_BRIGHTPAY_URL_AUTH_FAILURE =
  "THIRD_PARTY_BRIGHTPAY_URL_AUTH_FAILURE";
///thirdpartybrightpay/checkstatus
export const THIRD_PARTY_BRIGHTPAY_CHECK_STATUS =
  "THIRD_PARTY_BRIGHTPAY_CHECK_STATUS";
export const THIRD_PARTY_BRIGHTPAY_CHECK_STATUS_SUCCESS =
  "THIRD_PARTY_BRIGHTPAY_CHECK_STATUS_SUCCESS";
export const THIRD_PARTY_BRIGHTPAY_CHECK_STATUS_FAILURE =
  "THIRD_PARTY_BRIGHTPAY_CHECK_STATUS_FAILURE";
///thirdpartybrightpay/generateaccesstoken
export const THIRD_PARTY_BRIGHTPAY_GENERATE_ACCESS_TOKEN =
  "THIRD_PARTY_BRIGHTPAY_GENERATE_ACCESS_TOKEN";
export const THIRD_PARTY_BRIGHTPAY_GENERATE_ACCESS_TOKEN_SUCCESS =
  "THIRD_PARTY_BRIGHTPAY_GENERATE_ACCESS_TOKEN_SUCCESS";
export const THIRD_PARTY_BRIGHTPAY_GENERATE_ACCESS_TOKEN_FAILURE =
  "THIRD_PARTY_BRIGHTPAY_GENERATE_ACCESS_TOKEN_FAILURE";
///thirdpartybrightpay/assignemployer
export const THIRD_PARTY_BRIGHTPAY_ASSIGN_EMPLOYER =
  "THIRD_PARTY_BRIGHTPAY_ASSIGN_EMPLOYER";
export const THIRD_PARTY_BRIGHTPAY_ASSIGN_EMPLOYER_SUCCESS =
  "THIRD_PARTY_BRIGHTPAY_ASSIGN_EMPLOYER_SUCCESS";
export const THIRD_PARTY_BRIGHTPAY_ASSIGN_EMPLOYER_FAILURE =
  "THIRD_PARTY_BRIGHTPAY_ASSIGN_EMPLOYER_FAILURE";
///thirdpartybrightpay/unassign
export const THIRD_PARTY_BRIGHTPAY_UNASSIGN =
  "THIRD_PARTY_BRIGHTPAY_UNASSIGN";
export const THIRD_PARTY_BRIGHTPAY_UNASSIGN_SUCCESS =
  "THIRD_PARTY_BRIGHTPAY_UNASSIGN_SUCCESS";
export const THIRD_PARTY_BRIGHTPAY_UNASSIGN_FAILURE =
  "THIRD_PARTY_BRIGHTPAY_UNASSIGN_FAILURE";
///thirdpartybrightpay/sync/employees
export const THIRD_PARTY_BRIGHTPAY_SYNC_EMPLOYEES =
  "THIRD_PARTY_BRIGHTPAY_SYNC_EMPLOYEES";
export const THIRD_PARTY_BRIGHTPAY_SYNC_EMPLOYEES_SUCCESS =
  "THIRD_PARTY_BRIGHTPAY_SYNC_EMPLOYEES_SUCCESS";
export const THIRD_PARTY_BRIGHTPAY_SYNC_EMPLOYEES_FAILURE =
  "THIRD_PARTY_BRIGHTPAY_SYNC_EMPLOYEES_FAILURE";
///thirdpartybrightpay/employees/list
export const THIRD_PARTY_BRIGHTPAY_EMPLOYEE_LIST =
  "THIRD_PARTY_BRIGHTPAY_EMPLOYEE_LIST";
export const THIRD_PARTY_BRIGHTPAY_EMPLOYEE_LIST_SUCCESS =
  "THIRD_PARTY_BRIGHTPAY_EMPLOYEE_LIST_SUCCESS";
export const THIRD_PARTY_BRIGHTPAY_EMPLOYEE_LIST_FAILURE =
  "THIRD_PARTY_BRIGHTPAY_EMPLOYEE_LIST_FAILURE";

//thirdpartygpslive (per-company vehicle GPS tracking API key)
export const THIRD_PARTY_GPSLIVE_SAVE_CREDENTIALS =
  "THIRD_PARTY_GPSLIVE_SAVE_CREDENTIALS";
export const THIRD_PARTY_GPSLIVE_SAVE_CREDENTIALS_SUCCESS =
  "THIRD_PARTY_GPSLIVE_SAVE_CREDENTIALS_SUCCESS";
export const THIRD_PARTY_GPSLIVE_SAVE_CREDENTIALS_FAILURE =
  "THIRD_PARTY_GPSLIVE_SAVE_CREDENTIALS_FAILURE";

export const THIRD_PARTY_GPSLIVE_CHECK_STATUS =
  "THIRD_PARTY_GPSLIVE_CHECK_STATUS";
export const THIRD_PARTY_GPSLIVE_CHECK_STATUS_SUCCESS =
  "THIRD_PARTY_GPSLIVE_CHECK_STATUS_SUCCESS";
export const THIRD_PARTY_GPSLIVE_CHECK_STATUS_FAILURE =
  "THIRD_PARTY_GPSLIVE_CHECK_STATUS_FAILURE";

export const THIRD_PARTY_GPSLIVE_TEST_CONNECTION =
  "THIRD_PARTY_GPSLIVE_TEST_CONNECTION";
export const THIRD_PARTY_GPSLIVE_TEST_CONNECTION_SUCCESS =
  "THIRD_PARTY_GPSLIVE_TEST_CONNECTION_SUCCESS";
export const THIRD_PARTY_GPSLIVE_TEST_CONNECTION_FAILURE =
  "THIRD_PARTY_GPSLIVE_TEST_CONNECTION_FAILURE";

export const THIRD_PARTY_GPSLIVE_UNASSIGN =
  "THIRD_PARTY_GPSLIVE_UNASSIGN";
export const THIRD_PARTY_GPSLIVE_UNASSIGN_SUCCESS =
  "THIRD_PARTY_GPSLIVE_UNASSIGN_SUCCESS";
export const THIRD_PARTY_GPSLIVE_UNASSIGN_FAILURE =
  "THIRD_PARTY_GPSLIVE_UNASSIGN_FAILURE";

//thirdpartyvapi (per-company Virtual Receptionist — now MULTIPLE per company)
export const THIRD_PARTY_VAPI_LIST = "THIRD_PARTY_VAPI_LIST";
export const THIRD_PARTY_VAPI_LIST_SUCCESS =
  "THIRD_PARTY_VAPI_LIST_SUCCESS";
export const THIRD_PARTY_VAPI_LIST_FAILURE =
  "THIRD_PARTY_VAPI_LIST_FAILURE";

export const THIRD_PARTY_VAPI_DATA = "THIRD_PARTY_VAPI_DATA";
export const THIRD_PARTY_VAPI_DATA_SUCCESS =
  "THIRD_PARTY_VAPI_DATA_SUCCESS";
export const THIRD_PARTY_VAPI_DATA_FAILURE =
  "THIRD_PARTY_VAPI_DATA_FAILURE";

export const THIRD_PARTY_VAPI_CREATE = "THIRD_PARTY_VAPI_CREATE";
export const THIRD_PARTY_VAPI_CREATE_SUCCESS =
  "THIRD_PARTY_VAPI_CREATE_SUCCESS";
export const THIRD_PARTY_VAPI_CREATE_FAILURE =
  "THIRD_PARTY_VAPI_CREATE_FAILURE";

export const THIRD_PARTY_VAPI_UPDATE = "THIRD_PARTY_VAPI_UPDATE";
export const THIRD_PARTY_VAPI_UPDATE_SUCCESS =
  "THIRD_PARTY_VAPI_UPDATE_SUCCESS";
export const THIRD_PARTY_VAPI_UPDATE_FAILURE =
  "THIRD_PARTY_VAPI_UPDATE_FAILURE";

export const THIRD_PARTY_VAPI_DELETE = "THIRD_PARTY_VAPI_DELETE";
export const THIRD_PARTY_VAPI_DELETE_SUCCESS =
  "THIRD_PARTY_VAPI_DELETE_SUCCESS";
export const THIRD_PARTY_VAPI_DELETE_FAILURE =
  "THIRD_PARTY_VAPI_DELETE_FAILURE";

export const THIRD_PARTY_VAPI_PROVISION =
  "THIRD_PARTY_VAPI_PROVISION";
export const THIRD_PARTY_VAPI_PROVISION_SUCCESS =
  "THIRD_PARTY_VAPI_PROVISION_SUCCESS";
export const THIRD_PARTY_VAPI_PROVISION_FAILURE =
  "THIRD_PARTY_VAPI_PROVISION_FAILURE";

export const THIRD_PARTY_VAPI_LINK_TWILIO =
  "THIRD_PARTY_VAPI_LINK_TWILIO";
export const THIRD_PARTY_VAPI_LINK_TWILIO_SUCCESS =
  "THIRD_PARTY_VAPI_LINK_TWILIO_SUCCESS";
export const THIRD_PARTY_VAPI_LINK_TWILIO_FAILURE =
  "THIRD_PARTY_VAPI_LINK_TWILIO_FAILURE";

export const THIRD_PARTY_VAPI_TOGGLE =
  "THIRD_PARTY_VAPI_TOGGLE";
export const THIRD_PARTY_VAPI_TOGGLE_SUCCESS =
  "THIRD_PARTY_VAPI_TOGGLE_SUCCESS";
export const THIRD_PARTY_VAPI_TOGGLE_FAILURE =
  "THIRD_PARTY_VAPI_TOGGLE_FAILURE";

//telephony (Twilio number ordering — cross-sells the Virtual Receptionist)
export const CALL_PROVIDER_LIST = "CALL_PROVIDER_LIST";
export const CALL_PROVIDER_LIST_SUCCESS = "CALL_PROVIDER_LIST_SUCCESS";
export const CALL_PROVIDER_LIST_FAILURE = "CALL_PROVIDER_LIST_FAILURE";

export const TELEPHONE_NUMBER_AVAILABLE = "TELEPHONE_NUMBER_AVAILABLE";
export const TELEPHONE_NUMBER_AVAILABLE_SUCCESS =
  "TELEPHONE_NUMBER_AVAILABLE_SUCCESS";
export const TELEPHONE_NUMBER_AVAILABLE_FAILURE =
  "TELEPHONE_NUMBER_AVAILABLE_FAILURE";

export const TELEPHONE_NUMBER_PURCHASE = "TELEPHONE_NUMBER_PURCHASE";
export const TELEPHONE_NUMBER_PURCHASE_SUCCESS =
  "TELEPHONE_NUMBER_PURCHASE_SUCCESS";
export const TELEPHONE_NUMBER_PURCHASE_FAILURE =
  "TELEPHONE_NUMBER_PURCHASE_FAILURE";

export const TELEPHONE_NUMBER_LIST = "TELEPHONE_NUMBER_LIST";
export const TELEPHONE_NUMBER_LIST_SUCCESS = "TELEPHONE_NUMBER_LIST_SUCCESS";
export const TELEPHONE_NUMBER_LIST_FAILURE = "TELEPHONE_NUMBER_LIST_FAILURE";
